var map = {
	"./CMU_logo.png": 5098,
	"./argo_ai_logo.png": 4197,
	"./blogs_image.svg": 1108,
	"./brown_logo.png": 3825,
	"./contactMail.png": 3914,
	"./contact_avatar.png": 5131,
	"./coursera_logo.png": 8857,
	"./deeplearning_ai_logo.png": 774,
	"./delhivery_logo.png": 7311,
	"./dsc_logo.png": 3979,
	"./education.svg": 1803,
	"./experience.svg": 1071,
	"./feelingProud.svg": 2677,
	"./freecopy_logo.png": 1434,
	"./gcp_logo.png": 4375,
	"./github_logo.png": 9214,
	"./google_logo.png": 6038,
	"./home_ballet_picture.png": 6356,
	"./ibm_logo.png": 5539,
	"./intel_logo.jpg": 1021,
	"./legato_logo.png": 7147,
	"./microsoft_logo.png": 3953,
	"./mindmatters_logo.png": 395,
	"./mozilla_logo.png": 9105,
	"./muffito_logo.png": 3981,
	"./nptel_logo.png": 3862,
	"./profile_image.png": 8410,
	"./projects_image.svg": 5739,
	"./re2_logo.png": 2500,
	"./skill_image.png": 3394,
	"./stanford_logo.png": 4216,
	"./talksCardBack.svg": 7175,
	"./veritas_logo.png": 5557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;